<div class="approvals-flex-container">
  <div class="approvals-left-pannel">
    <mat-toolbar class="approvals-toolbar">
      @if (isSingleApproverObs | async) {
        <mat-select
          #approvalsList
          class="approvals-select"
          panelClass="approvals-select-panel"
          [(value)]="approvalsSelected"
          [(ngModel)]="approvalsSelected"
          (selectionChange)="approvalTypeChange(approvalsList.value)"
          >
          <!-- <mat-option value="ALL_FLOWS">All Flows</mat-option> -->
          @if (rolesService.isReviewer()) {
            <mat-option value="MY_APPROVALS"
              >My Approvals ({{ myApprovalsCount }})
            </mat-option>
          }
          <mat-option value="APPROVED">Production Ready ({{ productionReadyCount }})</mat-option>
          <mat-option value="PENDING">Pending</mat-option>
          <mat-option value="DECLINED">Declined</mat-option>
          <mat-option value="DEPLOYED">Deployed</mat-option>
        </mat-select>
      } @else {
        <div class="single-approver-title">
          Deployed
        </div>
      }
      <!-- This fills the remaining space of the current row -->
      <span class="fill-remaining-space"></span>
      <!-- New Floder & Sort Here -->
    </mat-toolbar>
    <div class="searchBlock">
      <input
        class="searchBtn"
        placeholder="Search"
        type="text"
        #searchApprovals
        value=""
        (input)="searchForApprovals(searchApprovals)"
        />
      </div>

      @if (approvals) {
        <app-approval-list
          [submissionList]="submissionsList"
          (selectedApproval)="selectedApproval($event)"
          [searchValue]="searchForApprovalsValue"
          >
        </app-approval-list>
      }
    </div>

    <div class="approvals-right-pannel">
      @if (approvals) {
        <app-approval-details
          [submission]="submissions"
          [changeLog]="changeLog"
          [submissionApproval]="submissionApproval"
          [approvalsSelected]="approvalsSelected"
          (clear)="resetSubmissions($event)"
        ></app-approval-details>
      }
    </div>
  </div>
